export default function RevenueChart({ orders }) {
  const days = [];
  const totals = {};
  orders.forEach((o) => {
    const key = (o.created_at || "").slice(0, 10);
    if (key) totals[key] = (totals[key] || 0) + (o.amount || 0);
  });
  const now = new Date();
  for (let i = 29; i >= 0; i--) {
    const d = new Date(now);
    d.setDate(d.getDate() - i);
    const key = d.toISOString().slice(0, 10);
    days.push({
      key,
      label: d.toLocaleDateString(undefined, { month: "short", day: "numeric" }),
      total: totals[key] || 0,
    });
  }
  const max = Math.max(...days.map((d) => d.total), 1);
  const sum = days.reduce((s, d) => s + d.total, 0);
  const W = 960;
  const H = 160;
  const TOP = 16;
  const barW = W / days.length;

  return (
    <div className="bg-[#0A0A0A] border border-white/5 p-8 mb-12" data-testid="revenue-chart">
      <div className="flex items-baseline justify-between mb-8">
        <div>
          <span className="text-xs tracking-[0.2em] uppercase text-zinc-500 block mb-2">Revenue — last 30 days</span>
          <span className="font-display text-3xl text-white" data-testid="chart-total">${sum.toFixed(2)}</span>
        </div>
        <span className="text-xs text-zinc-600">{days[0].label} — {days[days.length - 1].label}</span>
      </div>
      <svg viewBox={`0 0 ${W} ${H + TOP}`} className="w-full" role="img" aria-label="Revenue over the last 30 days">
        {days.map((d, i) => {
          const h = d.total > 0 ? Math.max((d.total / max) * (H - 10), 4) : 2;
          return (
            <rect
              key={d.key}
              data-testid={`chart-bar-${d.key}`}
              x={i * barW + 1.5}
              y={TOP + H - h}
              width={barW - 3}
              height={h}
              fill={d.total > 0 ? "#D4AF37" : "rgba(255,255,255,0.07)"}
            >
              <title>{`${d.label}: $${d.total.toFixed(2)}`}</title>
            </rect>
          );
        })}
        <line x1="0" y1={TOP + H + 0.5} x2={W} y2={TOP + H + 0.5} stroke="rgba(255,255,255,0.1)" strokeWidth="1" />
      </svg>
      <div className="flex justify-between mt-3">
        <span className="text-[10px] tracking-[0.15em] uppercase text-zinc-600">{days[0].label}</span>
        <span className="text-[10px] tracking-[0.15em] uppercase text-zinc-600">{days[14].label}</span>
        <span className="text-[10px] tracking-[0.15em] uppercase text-zinc-600">{days[days.length - 1].label}</span>
      </div>
    </div>
  );
}
